import { c as _c } from "react/compiler-runtime";
import React, { useMemo } from 'react';
import JBImage from 'components/essentials/JBImage';
import Link from 'components/consumer/Link';
import useProductAttributes from 'data-hooks/useProductAttributes/index';
import usePDPBreadcrumbs from 'data-hooks/usePDPBreadcrumbs';
import usePDPBasicDetails from 'components/consumer/PDP/state/context/usePDPBasicDetails';
import { PDP_CTA, trackPDPCtaClicked } from 'data-hooks/useEvents/pdpInteractionEvents';
import PDPInfoSectionLayout from './PDPInfoSectionLayout';
import getCategoryNavImage, { getCategoryLinksForSlug } from './getCategoryNavImage';
const PRODUCT_CARE_URL = '/product-care/';
const PRODUCT_CARE_LABEL = 'Product Care Detail';

// Care tab: the cleaning list that today only exists inside the
// details-and-care full-screen modal
const PDPInfoCareSection = () => {
  const $ = _c(17);
  const {
    data: t0
  } = useProductAttributes();
  const {
    productCareDetails
  } = t0;
  const {
    data: breadcrumbs
  } = usePDPBreadcrumbs();
  const {
    data: basicDetails
  } = usePDPBasicDetails();
  let t1;
  if ($[0] !== basicDetails?.attributes_min?.urlKey) {
    t1 = basicDetails?.attributes_min?.urlKey?.split("/").filter(Boolean)[0];
    $[0] = basicDetails?.attributes_min?.urlKey;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const urlKeyCategory = t1;
  let t2;
  if ($[2] !== breadcrumbs || $[3] !== urlKeyCategory) {
    t2 = getCategoryNavImage((breadcrumbs ?? []).slice(1, -1).map(_temp)) ?? getCategoryNavImage(getCategoryLinksForSlug(urlKeyCategory));
    $[2] = breadcrumbs;
    $[3] = urlKeyCategory;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const image = t2;
  let t3;
  if ($[5] !== image) {
    t3 = !!image && <div className="aspect-video w-full overflow-hidden"><JBImage className="w-full h-full object-cover" src={image.src} alt={image.alt} ar="16:9" sizes="(max-width: 767px) 100vw, 30vw" /></div>;
    $[5] = image;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const aside = t3;
  let t4;
  if ($[7] !== productCareDetails) {
    t4 = productCareDetails ?? [];
    $[7] = productCareDetails;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t4) {
    t5 = t4.map(_temp2);
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t5) {
    t6 = <ul className="list-disc m-0 pl-4" data-xc="PDPProductCareList">{t5}</ul>;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Link className="inline-block mt-4 text-sm text-brand no-underline hover:cursor-pointer hover:underline" to={PRODUCT_CARE_URL} target="_blank" data-xc="PDPProductCareDetailLink" rel="noopener noreferrer" onClick={_temp3}>{PRODUCT_CARE_LABEL}</Link>;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== aside || $[15] !== t6) {
    t8 = <PDPInfoSectionLayout aside={aside}>{t6}{t7}</PDPInfoSectionLayout>;
    $[14] = aside;
    $[15] = t6;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
};
export default PDPInfoCareSection;
function _temp(t0) {
  const {
    link
  } = t0;
  return link;
}
function _temp2(careItem) {
  return <li key={careItem} className="text-sm text-gray mb-2">{careItem}</li>;
}
function _temp3() {
  return trackPDPCtaClicked({
    cta: PDP_CTA.PRODUCT_CARE_DETAILS,
    text: PRODUCT_CARE_LABEL,
    targetUrl: PRODUCT_CARE_URL
  });
}